import React, { useState, useEffect } from "react";
import { agrogestao } from "@/api/agrogestaoClient";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Loader2, Check } from "lucide-react";

export default function ArmazemForm({ armazem, onSuccess, onCancel }) {
  const propriedadeId = localStorage.getItem("propriedade_selecionada");

  const [formData, setFormData] = useState({
    nome: "",
    tipo: "silo_proprio",
    capacidade_total: "",
    unidade_capacidade: "sacas",
    localizacao: "",
    responsavel: "",
    custo_armazenagem_mes: "",
    status: "ativo",
    observacoes: ""
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (armazem) {
      setFormData({
        nome: armazem.nome || "",
        tipo: armazem.tipo || "silo_proprio",
        capacidade_total: armazem.capacidade_total?.toString() || "",
        unidade_capacidade: armazem.unidade_capacidade || "sacas",
        localizacao: armazem.localizacao || "",
        responsavel: armazem.responsavel || "",
        custo_armazenagem_mes: armazem.custo_armazenagem_mes?.toString() || "",
        status: armazem.status || "ativo",
        observacoes: armazem.observacoes || ""
      });
    }
  }, [armazem]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    const data = {
      ...formData,
      propriedade_id: propriedadeId,
      capacidade_total: parseFloat(formData.capacidade_total) || 0,
      custo_armazenagem_mes: parseFloat(formData.custo_armazenagem_mes) || 0
    };

    if (armazem) {
      await agrogestao.entities.Armazem.update(armazem.id, data);
    } else {
      await agrogestao.entities.Armazem.create(data);
    }

    setSaving(false);
    onSuccess();
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div className="col-span-2 space-y-2">
          <Label>Nome do Armazém *</Label>
          <Input
            placeholder="Ex: Silo 01, Armazém Principal..."
            value={formData.nome}
            onChange={(e) => setFormData({ ...formData, nome: e.target.value })}
            required
          />
        </div>

        <div className="space-y-2">
          <Label>Tipo *</Label>
          <Select value={formData.tipo} onValueChange={(v) => setFormData({ ...formData, tipo: v })}>
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="silo_proprio">Silo Próprio</SelectItem>
              <SelectItem value="silo_terceiro">Silo Terceiro</SelectItem>
              <SelectItem value="armazem_proprio">Armazém Próprio</SelectItem>
              <SelectItem value="armazem_terceiro">Armazém Terceiro</SelectItem>
              <SelectItem value="bags">Big Bags</SelectItem>
              <SelectItem value="tulha">Tulha</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label>Status</Label>
          <Select value={formData.status} onValueChange={(v) => setFormData({ ...formData, status: v })}>
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="ativo">Ativo</SelectItem>
              <SelectItem value="inativo">Inativo</SelectItem>
              <SelectItem value="manutencao">Em Manutenção</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label>Capacidade Total *</Label>
          <Input
            type="number"
            placeholder="0"
            value={formData.capacidade_total}
            onChange={(e) => setFormData({ ...formData, capacidade_total: e.target.value })}
            required
          />
        </div>

        <div className="space-y-2">
          <Label>Unidade</Label>
          <Select value={formData.unidade_capacidade} onValueChange={(v) => setFormData({ ...formData, unidade_capacidade: v })}>
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="sacas">Sacas (60kg)</SelectItem>
              <SelectItem value="toneladas">Toneladas</SelectItem>
              <SelectItem value="kg">Quilogramas</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label>Localização</Label>
          <Input
            placeholder="Local do armazém"
            value={formData.localizacao}
            onChange={(e) => setFormData({ ...formData, localizacao: e.target.value })}
          />
        </div>

        <div className="space-y-2">
          <Label>Responsável</Label>
          <Input
            placeholder="Nome do responsável"
            value={formData.responsavel}
            onChange={(e) => setFormData({ ...formData, responsavel: e.target.value })}
          />
        </div>

        {(formData.tipo === 'silo_terceiro' || formData.tipo === 'armazem_terceiro') && (
          <div className="col-span-2 space-y-2">
            <Label>Custo de Armazenagem (R$/mês)</Label>
            <Input
              type="number"
              step="0.01"
              placeholder="0,00"
              value={formData.custo_armazenagem_mes}
              onChange={(e) => setFormData({ ...formData, custo_armazenagem_mes: e.target.value })}
            />
          </div>
        )}

        <div className="col-span-2 space-y-2">
          <Label>Observações</Label>
          <Textarea
            placeholder="Observações..."
            value={formData.observacoes}
            onChange={(e) => setFormData({ ...formData, observacoes: e.target.value })}
            rows={2}
          />
        </div>
      </div>

      <div className="flex gap-3 pt-4">
        <Button type="button" variant="outline" onClick={onCancel} className="flex-1">
          Cancelar
        </Button>
        <Button type="submit" disabled={saving} className="flex-1 bg-[#1B4332] hover:bg-[#2D6A4F]">
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Check className="w-4 h-4 mr-2" />{armazem ? "Atualizar" : "Cadastrar"}</>}
        </Button>
      </div>
    </form>
  );
}
